function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a5677613-85d9-4413-8a18-debbd7d8c5ea {\n        fill: #fff;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "a5677613-85d9-4413-8a18-debbd7d8c5ea",
  points: "144 218.7 144 232.8 162.6 234 184.8 275.1 157.8 357.3 265.2 357.3 265.2 292.2 243.9 292.2 246 320.1 206.7 339.3 194.1 291.9 210.3 236.7 261.9 240 261.9 218.7 188.4 218.7 226.2 172.8 190.8 172.8 168 218.7 144 218.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "a5677613-85d9-4413-8a18-debbd7d8c5ea",
  d: "M320.7,448.5l-38.4-74.7H239.4l-41.7,54.9,9.6-54.9H136.5v21.3l27-2.1,15.6,75.6L162,557.4l-25.5-3.3v21.3H239.1V554.1L207.6,558l-14.4-63.6,90.9,19.8Zm-63.9,40.2-66-4.8,6.3-36,58.8-50.1,21.6,50.7Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "a5677613-85d9-4413-8a18-debbd7d8c5ea",
  points: "499.5 554.1 499.5 575.4 596.4 575.4 596.4 554.1 569.4 557.4 553.8 484.5 573.3 373.8 499.5 373.8 499.5 395.1 526.5 393 542.1 468.6 525.9 557.4 499.5 554.1"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "a5677613-85d9-4413-8a18-debbd7d8c5ea",
  points: "293.1 31.2 411.3 31.2 479.4 78 501.9 63 418.8 0 285.6 0 202.5 63 225 78 293.1 31.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "a5677613-85d9-4413-8a18-debbd7d8c5ea",
  d: "M579,218.7H456.9v21l69.3-9,22.5,59.4-81-37.5-43.5,58.8,24.6,45.9H578.4L564,290.4ZM532.8,334.5l-53.1,10.2-6.9-33.3,17.7-30,52.8,24.3Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "a5677613-85d9-4413-8a18-debbd7d8c5ea",
  points: "439.2 271.5 439.2 218.7 382.2 218.7 339.6 316.8 331.5 299.4 358.5 218.7 278.7 218.7 278.7 240 303.9 238.2 322.8 283.5 303 337.8 278.7 336 278.7 357.3 384.6 357.3 384.6 336 349.2 337.5 344.4 327.3 398.4 255 439.2 271.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "a5677613-85d9-4413-8a18-debbd7d8c5ea",
  d: "M156.3,201.6V136.5H135l2.1,26.4L71.4,189.6,56.1,135.3l114.6-24L138.9,63H45L6,135.9l39,65.7ZM74.7,77.1l30-2.1,10.5,25.8L54.3,125.7Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "a5677613-85d9-4413-8a18-debbd7d8c5ea",
  points: "638.1 664.2 631.2 660.3 669.9 611.4 702 613.8 702 592.5 649.5 592.5 623.4 656.1 609.6 648.3 616.2 592.5 536.4 592.5 536.4 613.8 566.7 611.7 598.5 657.3 605.7 660.9 570.3 711.6 536.4 709.8 536.4 731.1 592.2 731.1 615.3 665.4 624.9 670.2 625.5 731.1 705 731.1 705 709.8 673.2 711.3 638.1 664.2"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "a5677613-85d9-4413-8a18-debbd7d8c5ea",
  points: "704.4 270 689.4 247.5 626.4 330.6 626.4 463.8 689.4 546.9 704.4 524.4 657.6 456.3 657.6 338.1 704.4 270"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "a5677613-85d9-4413-8a18-debbd7d8c5ea",
  points: "673.2 181.8 638.1 134.7 631.2 130.8 669.9 81.9 702 84.3 702 63 649.5 63 623.4 126.6 609.6 118.8 616.2 63 536.4 63 536.4 84.3 566.7 82.2 598.5 127.8 605.7 131.4 570.3 182.1 536.4 180.3 536.4 201.6 592.2 201.6 615.3 135.9 624.9 140.7 625.5 201.6 705 201.6 705 180.3 673.2 181.8"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "a5677613-85d9-4413-8a18-debbd7d8c5ea",
  points: "411.3 762.9 293.1 762.9 225 716.1 202.5 731.1 285.6 794.1 418.8 794.1 501.9 731.1 479.4 716.1 411.3 762.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "a5677613-85d9-4413-8a18-debbd7d8c5ea",
  d: "M137.1,692.4,71.4,719.1,56.1,664.8l114.6-24-31.8-48.3H45L6,665.4l39,65.7H156.3V666H135ZM74.7,606.6l30-2.1,10.5,25.8L54.3,655.2Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "a5677613-85d9-4413-8a18-debbd7d8c5ea",
  points: "0.3 524.4 15.3 546.9 78.3 463.8 78.3 330.6 15 247.5 0 270 47.1 338.1 47.1 456.3 0.3 524.4"
}));

function SvgHwiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b289f6c3-6217-43e9-a4d5-1846139f79f8",
    "data-name": "\\uB808\\uC774\\uC5B4 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 705 794.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHwiLogo);
export default __webpack_public_path__ + "static/media/hwi-logo.7d29f316.svg";
export { ForwardRef as ReactComponent };